export const appRootId = "root";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const rootElement = document.getElementById(appRootId)!;

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};
